<template>
  <div class="hot-tab">
    <ul class="tab-menu">
      <li :class="{'on': active == '0'}" @click="changeTab(0)"><a href="javascript:;">新手课程</a></li>
      <li :class="{'on': active == '1'}" @click="changeTab(1)"><a href="javascript:;">优秀方案</a></li>
    </ul>
    <div class="tab-content">
      <ul class="tab-content__item" :class="{'on': active == '0'}">
          <li v-for="(newCourseList, index) in recommendData.newCourseList" :key="index">
            <a :href="`${www}/study/course/${newCourseList.courseId}`">
              <img :src="newCourseList.coverImage" :alt="newCourseList.courseName"
              :data-src="newCourseList.coverImage"
              :onerror="defaultImg">
              <div class="tab-content__info">
                <h3>{{newCourseList.courseName}}</h3>
                <p>{{newCourseList.showLearnCount}}人学过</p>
              </div>
            </a>
          </li>
      </ul>
      <ul class="tab-content__item" :class="{'on': active == '1'}">
        <li v-for="(schemeList, index) in recommendData.schemeList" :key="index">
            <a :href="`${www}/scheme/detail?id=${schemeList.id}&tag=${schemeList.schemeType}`">
              <img :src="schemeList.imagePath" :alt="schemeList.schemeName"
              :data-src="schemeList.imagePath"
              :onerror="defaultImg">
              <div class="tab-content__info">
                <h3>{{schemeList.schemeName}}</h3>
                <p>
                  {{schemeList.totalArea}}<span v-if="schemeList.totalArea">m²</span>
                  <span v-if="schemeList.totalArea">|</span>
                  {{schemeList.styleName}}
                  <span v-if="schemeList.styleName">|</span>
                  {{schemeList.schemeImageCount}}图
                </p>
              </div>
            </a>
          </li>
      </ul>
    </div>
  </div>
</template>

<script>
import utilsImg from '@3vjia/v-utils/src/img';
import { apiGetRigesterRecommend } from '../libs/service';
import { studyImg, defaultImg } from '../libs/constants';
import { handleMillion } from '../libs/utils';

export default {
  name: 'reg-recommend',
  props: {
    platformapi: { type: String, default: '' },
    www: { type: String, default: '' },
  },
  data() {
    return {
      active: '0',
      recommendData: {},
      defaultImg: `this.src='${defaultImg}?x-oss-process=image/resize,m_fill,h_166,w_260'`,
    };
  },
  created() {
    this.getRigesterRecommend();
  },
  methods: {
    changeTab(num) {
      this.active = num;
    },
    getRigesterRecommend() {
      apiGetRigesterRecommend(this.platformapi, (res) => {
        this.recommendData = res;
        this.recommendData.newCourseList.forEach((element) => {
          const data = element;
          data.coverImage = utilsImg.webpFormat(`${studyImg}/${data.pccoverImage || data.pCCoverImage}?x-oss-process=image/resize,m_fill,h_166,w_260`, false);
          data.showLearnCount = handleMillion(data.showLearnCount);
        });
        this.recommendData.schemeList.forEach((element) => {
          const data = element;
          data.imagePath = data.imagePath.charAt(0) !== '/' ? `/${data.imagePath}` : data.imagePath;
          data.imagePath = utilsImg.platImgFormat(data.imagePath, 260, 160);
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../libs/mixin.scss';
ul, li, h3, p{
  padding: 0;
  margin: 0;
  list-style: none;
}
.hot-tab {
  margin: 20px 40px 40px;
  .tab-menu {
    display: flex;
    li {
      margin-right: 30px;
      color: #666;
      font-size: 16px;
      line-height: 1.8;
      a {
        color: #666;
        text-decoration: none;
        &:hover {
          color: #147ffa;
        }
      }
      &.on {
        border-bottom: 2px solid #147ffa;
        font-weight: bold;
        a {
          color: #147ffa;
        }
      }
    }
  }
  .tab-content {
    margin-top: 12px;
    &__item {
      display: none;
      justify-content: space-between;
      &.on {
        display: flex;
      }
      li {
        line-height: 2;
        border-radius:4px;
        overflow: hidden;
        &:hover {
          box-shadow:0px 2px 16px 0px rgba(0,0,0,0.12);
        }
        a {
          color: inherit;
          text-decoration: none;
          &:hover {
            color: #147ffa;
          }
        }
        img {
          width: 260px;
          height: 166px;
          vertical-align: top;
        }
        .tab-content__info {
          padding: 10px;
          width: 260px;
          box-sizing: border-box;
          h3 {
            font-size: 16px;
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
          }
          p {
            color: #999;
            font-size: 14px;
          }
        }
      }
    }
  }
}
</style>
